import { RouterProvider, createBrowserRouter, createHashRouter } from 'react-router';
import { Providers } from './app/Providers';
import { routes } from './routes';
import { ROUTER_MODE } from './env';

/**
 * Produkcija koristi obični router (čisti URL-ovi, `app.soultraining.hr/trening`).
 * Hash router postoji samo za preglede na hostovima koji ne mogu servirati SPA
 * fallback — tada rute žive iza `#/`, bez izmjene ijedne komponente.
 */
const router = ROUTER_MODE === 'hash' ? createHashRouter(routes) : createBrowserRouter(routes);

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
